import Splide from "@splidejs/splide";
import '@splidejs/splide/css';
document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#image-carousel', {
      heightRatio: 0.5625,
    } ).mount();
  } );